import { useEffect, useState } from 'react'

export const noop = () => {}

export function on(obj, ...args) {
  if (obj && obj.addEventListener) {
    obj.addEventListener(...args)
  }
}

export function off(obj, ...args) {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(...args)
  }
}

const usePermission = (permissionDesc) => {
  let mounted = true
  let permissionStatus = null

  const [state, setState] = useState()

  const onChange = () => {
    if (mounted && permissionStatus) {
      setState(permissionStatus.state)
    }
  }

  const changeState = () => {
    onChange()
    on(permissionStatus, 'change', onChange)
  }

  useEffect(() => {
    try {
      navigator.permissions
        .query(permissionDesc)
        .then((status) => {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          permissionStatus = status
          changeState()
        })
        .catch(noop)

      return () => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        mounted = false
        permissionStatus && off(permissionStatus, 'change', onChange)
      }
    } catch (e) {
      setState('granted')
    }
  }, [])

  return state
}

export default usePermission
